import GoalsAdapter from './base';

export default class Subject extends GoalsAdapter {
  modelNamePlural = 'subjects';
}
